import * as React from 'react';
import * as _ from 'underscore';
//const compareObjects = require('fast-deep-equal');
const webfontloader = require('pdc-platform-webfontloader');

import { IValuesCollection, getThemeObj, state as appThemeState } from '../../../_common/platform/ts/appTheme';

export function ThemeRenderer(props: { theme: IValuesCollection; levels: string[]; context?: string }) {
    const theme = React.useMemo(() => getThemeObj(props.theme), [JSON.stringify(props.theme)]);

    React.useEffect(() => {
        let fonts = _.filter(_.keys(theme), (key) => {
            return /(^#font)|(-font$)/.test(key);
        });

        fonts = _.unique(fonts);

        _.each(fonts, (key) => {
            const family = theme[key];

            if (family == null || typeof family !== 'string') {
                return;
            }

            webfontloader.load({
                google: {
                    families: [family]
                },
                classes: false
            });
        });
    }, [theme]);

    const context = props.context || '';

    const content = _.map(
        _.filter(appThemeState.templates, (obj) => {
            return _.intersection(obj.levels, props.levels).length > 0;
        }),
        (obj, i) => {
            let str = obj.template({
                //Color: Color,  // OE -- it was undefinded !!!!
                theme: theme
            });

            str = str.replace(/\{\{render_context\}\}/g, context);

            return (
                <style
                    key={i}
                    dangerouslySetInnerHTML={{
                        __html: str
                    }}
                ></style>
            );
        }
    );

    return <div className="theme-renderer">{content}</div>;
}
